/* Wallview — frontend controller for "View on your wall" modal */
(function () {
  'use strict';

  const API_BASE = '/apps/wallview/api';
  const cfg = window.WALLVIEW_CONFIG || {};
  const SERVICE_UNAVAILABLE = 'Wallview is temporarily unavailable. Please try again later. Thank you for your patience.';

  const modal     = document.getElementById('wv-modal');
  if (!modal) return;

  const stateEls  = modal.querySelectorAll('[data-wv-state]');
  const dropZone  = modal.querySelector('[data-wv-drop]');
  const fileInput = modal.querySelector('[data-wv-input]');
  const preview   = modal.querySelector('[data-wv-preview]');
  const dropInner = modal.querySelector('.wv-drop__inner');
  const genBtn    = modal.querySelector('[data-wv-generate]');
  const quotaEl   = modal.querySelector('[data-wv-quota]');
  const quotaAfter= modal.querySelector('[data-wv-quota-after]');
  const statusEl  = modal.querySelector('[data-wv-status]');
  const resultImg = modal.querySelector('[data-wv-result]');
  const dlBtn     = modal.querySelector('[data-wv-download]');
  const errMsg    = modal.querySelector('[data-wv-error-msg]');

  let chosenFile = null;

  // ── Open / close ──────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-wv-open]');
    if (trigger) { e.preventDefault(); openModal(); }
    if (e.target.closest('[data-wv-close]')) closeModal();
    if (e.target.closest('[data-wv-restart]')) showState('upload');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!cfg.isLoggedIn) {
      showState('login');
      return;
    }
    showState('upload');
    loadQuota();
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    resetUploadUI();
  }
  function showState(name) {
    modal.setAttribute('data-wv-active-state', name);
    stateEls.forEach((el) => { el.hidden = el.getAttribute('data-wv-state') !== name; });
  }

  async function readApiResponse(resp) {
    // Shopify or an upstream gateway can return an HTML error page.
    // Keep that response out of JSON parsing and customer-facing messages.
    if (!/application\/json/i.test(resp.headers.get('content-type') || '')) {
      console.warn('Wallview API response:', resp.status, resp.headers.get('content-type'));
      throw new Error(SERVICE_UNAVAILABLE);
    }
    try {
      const data = await resp.json();
      if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('invalid_response');
      return data;
    } catch (_) {
      throw new Error(SERVICE_UNAVAILABLE);
    }
  }

  // ── Quota ─────────────────────────────────────────────────────────
  async function loadQuota() {
    if (quotaEl) quotaEl.textContent = 'Loading your quota…';
    try {
      const resp = await fetch(`${API_BASE}/quota`, { credentials: 'include' });
      const data = await readApiResponse(resp);
      if (!resp.ok) throw new Error(data.error || 'quota_failed');
      renderQuota(data);
      if (data.remaining <= 0 && genBtn) {
        genBtn.disabled = true;
        if (quotaEl) quotaEl.textContent = `You've used all ${data.quota} free generations.`;
      }
    } catch (err) {
      if (quotaEl) quotaEl.textContent = SERVICE_UNAVAILABLE;
    }
  }
  function renderQuota(data) {
    if (quotaEl) quotaEl.innerHTML = `<strong>${data.remaining}</strong> of ${data.quota} generations remaining.`;
    if (quotaAfter) quotaAfter.innerHTML = `<strong>${data.remaining}</strong> of ${data.quota} generations left.`;
  }

  // ── File picker ───────────────────────────────────────────────────
  if (fileInput) {
    fileInput.addEventListener('change', () => {
      const f = fileInput.files && fileInput.files[0];
      if (f) handleFile(f);
    });
  }
  if (dropZone) {
    ['dragover', 'dragenter'].forEach((ev) => dropZone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropZone.classList.add('is-drag');
    }));
    ['dragleave', 'drop'].forEach((ev) => dropZone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropZone.classList.remove('is-drag');
    }));
    dropZone.addEventListener('drop', (e) => {
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) handleFile(f);
    });
  }
  function handleFile(f) {
    if (!/^image\/(jpeg|png|webp)$/i.test(f.type)) {
      alert('Please choose a JPEG, PNG or WebP image.');
      return;
    }
    if (f.size > 8 * 1024 * 1024) {
      alert('Image is too large (max 8 MB).');
      return;
    }
    chosenFile = f;
    window.MurallsFunnel?.trackUpload('wallview');
    if (preview) {
      preview.src = URL.createObjectURL(f);
      preview.hidden = false;
    }
    if (dropInner) dropInner.style.display = 'none';
    if (genBtn) genBtn.disabled = false;
  }
  function resetUploadUI() {
    chosenFile = null;
    if (fileInput) fileInput.value = '';
    if (preview) { preview.src = ''; preview.hidden = true; }
    if (dropInner) dropInner.style.display = '';
    if (genBtn) genBtn.disabled = true;
  }

  // ── Generate ──────────────────────────────────────────────────────
  if (genBtn) {
    genBtn.addEventListener('click', () => {
      if (!chosenFile) return;
      submitGeneration(chosenFile);
    });
  }

  async function submitGeneration(file) {
    let customerMessage = SERVICE_UNAVAILABLE;
    showState('loading');
    if (statusEl) statusEl.textContent = 'Uploading your photo…';

    const fd = new FormData();
    fd.append('wall_image', file, file.name || 'wall.jpg');
    fd.append('product_image_url', cfg.productImageUrl || '');

    try {
      if (statusEl) statusEl.textContent = 'Sending to the visualizer…';
      const resp = await fetch(`${API_BASE}/generate`, {
        method: 'POST',
        credentials: 'include',
        body: fd,
      });
      const data = await readApiResponse(resp);
      if (!resp.ok) {
        const map = {
          login_required: 'Please sign in to use this feature.',
          quota_exceeded: 'You have used all your free generations.',
          rate_limited: 'Too many requests — please wait a few seconds.',
          unsupported_format: 'Use JPEG, PNG or WebP.',
          file_too_large: 'Image is too large (max 8 MB).',
        };
        customerMessage = map[data.error] || SERVICE_UNAVAILABLE;
        throw new Error(customerMessage);
      }
      // Success
      if (resultImg) resultImg.src = data.url;
      if (dlBtn) dlBtn.href = data.url;
      renderQuota(data);
      showState('result');
    } catch (err) {
      if (errMsg) errMsg.textContent = customerMessage;
      showState('error');
    }
  }
})();
